import type { BetslipSession } from "../../../contract";
import type { BetslipApplicationState } from "../BetslipApplicationState";

export const getSportsbookBetslipSession = (state: BetslipApplicationState): BetslipSession => state.sportsbookSession;
